import React from "react";
import ErrorPageComponent from "../../components/ErrorPage";

const ErrorPage = () => {
  return <ErrorPageComponent />;
};

export default ErrorPage;
